import { $http } from '@/common/api/http.service';

const basePath = 'api/system/nps-survey';
// Background calls: a failure must never surface to the user, so skip the error snackbar.
const config = { errorHandle: false };

export default {
    claim: () => $http.post(basePath + '/claim', null, config),
    shown: (id) => $http.post(basePath + '/prompts/' + id + '/shown', null, config),
    submitted: (id) => $http.post(basePath + '/prompts/' + id + '/submitted', null, config),
};
